<template>
	<u-banner v-if="unit.control_code == 'banner'"></u-banner>
	<u-activity v-else-if="unit.control_code == 'activity'"></u-activity>
	<u-channel v-else-if="unit.control_code == 'img_advert'"></u-channel>
	<u-new-product v-else-if="unit.control_code == 'update'"></u-new-product>
	<u-recommend-product v-else-if="unit.control_code == 'waterfall_flow'"></u-recommend-product>
	<u-channel-banner v-else-if="unit.control_code == 'channel_banner'"></u-channel-banner>
	<u-channel-image v-else-if="unit.control_code == 'channel_image_list'"></u-channel-image>
	<u-channel-product v-else-if="unit.control_code == 'channel_product'"></u-channel-product>
	<u-code v-else-if="unit.control_code == 'code'"></u-code>
	<u-link-area v-else-if="unit.control_code == 'link_area'"></u-link-area>
</template>

<script>
	import uBanner from './unit/pc/banner.vue'
	import uActivity from './unit/pc/activity.vue'
	import uChannel from './unit/pc/channel.vue'
	import uNewProduct from './unit/pc/new_product.vue'
	import uRecommendProduct from './unit/pc/recommend_product.vue'
	import uChannelBanner from './unit/pc/channel_banner.vue'
	import uChannelImage from './unit/pc/channel_image_list.vue'
	import uChannelProduct from './unit/pc/channel_product.vue'
	import uCode from '@/submodule/decorate_manage/components/unit/pc/code.vue'
	import uLinkArea from '@/submodule/decorate_manage/components/unit/link_area.vue'
	
	export default {
		components: {
			uBanner,
			uActivity,
			uChannel,
			uNewProduct,
			uRecommendProduct,
			uChannelBanner,
			uChannelImage,
			uChannelProduct,
			uCode,
			uLinkArea
		},
		
		props: {
			unit: Object
		}
	}
</script>